import { toast } from "sonner";
import API, { startGoogleLogin } from "./api";

export const POST_LOGIN_KEY = "om_post_login_path";

export async function startCheckout(user, scope, ref, lookup_key) {
  if (!user) {
    toast.info("Create a free account to purchase and track progress. Sending you to sign in…");
    sessionStorage.setItem(POST_LOGIN_KEY, window.location.pathname + window.location.hash);
    setTimeout(startGoogleLogin, 1400);
    return;
  }
  try {
    const r = await API.post("/payments/checkout", { lookup_key, scope, ref, origin_url: window.location.origin });
    window.location.href = r.data.checkout_url;
  } catch {
    toast.error("Could not start checkout. Please try again.");
  }
}
